// ADD SERVICE BOX OVERLAY ON PRODUCT TILE
let triggerImplicitChooseLaterOnClickOutside = true;
const OVERLAY = 'overlay';
const showOverlayServiceBox = function (elm) {

    let productToAddToCart;
    let errorBoxForAddToCart;
    let cartStoreHasChanged = false;
    let cartTypeHasChanged = false;
    let cartHasStore = false;
    const SERVICE_TYPE_CORNER_SHOP_DELIVERY = 'CORNERSHOP_HOME_DELIVERY';
    const SERVICE_TYPE_EXPRESS_DELIVERY = 'SERVICE_TYPE_EXPRESS_DELIVERY';
    const SERVICE_TYPE_ECONO_DELIVERY = 'SERVICE_TYPE_ECONO_DELIVERY';
    const CHOOSE_LATER = 'CHOOSE_LATER';

    function initWebviewOverlay() {
        bindWebviewEvents();
    }

    const removeOverlayServiceBox = function () {
        if ($('.overlayServiceBox:not(.overlayCopy)').closest('.freezeSlide')) {
            $('.overlayServiceBox:not(.overlayCopy)').closest('.freezeSlide').slick('slickSetOption', 'draggable', true, true);
        }

        //close dropdown if open
        let $variantSelector = $('.action__select-variant.active');
        if ($variantSelector.length) {
            $('.overlayServiceBox.overlay-service-box.overlayMain:not(.overlayCopy)').trigger('click');
        }

        $('.overlayServiceBox:not(.overlayCopy)').remove();
        $('.overlay-min-height').removeClass('overlay-min-height');
        $('body').removeClass('overlay-service-open');
        TINK.updateStatusNotification(window['overlayCloseMessage']);
    };

    let handleOuterClick = function (event) {
        let overlayBox = $('.overlayMain:not(.overlayCopy)')[0];
        if (typeof overlayBox !== 'undefined' && !overlayBox.contains(event.target)) {
            $(document).off('mousedown', handleOuterClick);
            triggerImplicitChooseLaterAction();
            gaPushOnOverlayClose();
        }
    };

    let manageOverlayOuterClick = function () {
        $(document).on('mousedown', handleOuterClick);
    };

    let triggerImplicitChooseLaterAction = function () {
        if (!triggerImplicitChooseLaterOnClickOutside) {
            removeOverlayServiceBox();
            return;
        }

        let $deliverySecondContainer = $('.delivery-second-container');
        if ($deliverySecondContainer.length === 0) {
            removeOverlayServiceBox();
            return;
        }

        let $chooseLaterOption = $deliverySecondContainer.find('input[type="radio"]#later-choice');
        let $confirmButton = $deliverySecondContainer.find('.confirm-delivery');

        if ($chooseLaterOption.length && $confirmButton.length) {
            $chooseLaterOption.prop('checked', true).change();
            $confirmButton.click();
        }
    };

    const openOverlayServiceBox = function (productTile, fromSearch) {
        removeOverlayServiceBox();
        let $targetTileTile;
        let $overlayServiceBox = $('.overlayServiceBox');
        let $cloneOverlayServiceBox = $overlayServiceBox.clone();
        let $overlayInputField = $cloneOverlayServiceBox.find('#servicePostalCodeBox');

        // OVERLAY CONDITION - PDP
        if (productTile.hasClass('add-to-cart-pdp') || productTile.hasClass('pdpDetailsContainer')) {
            $targetTileTile = $('.pdpDetailsContainer');
        } else if ($('#cartGeniusContent').length && productTile.closest('.cartGeniusContainer').length > 0) {
            $targetTileTile = productTile.closest('.cartGeniusContainer');
        }  else if (productTile.closest('.double-product-tile').length) {
            $targetTileTile = productTile.closest('.double-product-tile');
        } else {
            $targetTileTile = productTile.closest('.default-product-tile');
            $targetTileTile.addClass('overlay-min-height in-progress');
        }

        // OVERLAY AUTRES VARIETE FREQUEMMENT ACHETES ENSEMBLES PDP
        if (productTile.closest('.pdp--upsell-container').length) {
            $targetTileTile = $('.up-sell-container');
        } else if (productTile.closest('.slick-upSell').length) {
            // OVERLAY AUTRES VARIETE FREQUEMMENT ACHETES ENSEMBLES PLP
            $targetTileTile = $('.up-sell-container');
        } else if (productTile.closest('.cart-hyf').length) {
            // OVERLAY dans produits recommandés ou upass
            $targetTileTile = productTile.closest('.cart-hyf');
        } else if (productTile.closest('.slick-track').length) {
            // OVERLAY dans un carousel
            $targetTileTile = productTile.closest('.slick-list');
            if (!Revealizr.isMobileSize){
                productTile.closest('.active-carousel').slick('slickSetOption', 'draggable', false, true);
                productTile.closest('.active-carousel').addClass('freezeSlide');
            }
        } else if ($('.cart-genius-side-panel').length && productTile.closest('.cart-genius-side-panel').length > 0) {
            // OVERLAY dans le side panel cart genius
            $targetTileTile = productTile.closest('.cart-genius-side-panel');
        }

        // OVERLAY CONDITION - SLIM TILES IN CAROUSEL || AUTO COMPLETE
        let $tileSlimCarousel = $targetTileTile.closest('.tiles--carousel');

        //APPEND OVERLAY
        if ($tileSlimCarousel.length) {
            $tileSlimCarousel.closest('.tiles--carousel-container').prepend($cloneOverlayServiceBox);
        } else {
            $targetTileTile.prepend($cloneOverlayServiceBox);
        }

        $('body').addClass('overlay-service-open');

        // CHECK IF USER HAS ALREADY ENTERED A POSTAL CODE
        let getUserEnteredPostalCode = sessionStorage.getItem('enteredPostalCode');
        if (getUserEnteredPostalCode && typeof overlaySkipStepOne !== 'undefined' && overlaySkipStepOne !== 'false') {
            loadDeliverySecondScreen(getUserEnteredPostalCode);
            $cloneOverlayServiceBox.removeClass('overlayCopy');
        } else {
            $cloneOverlayServiceBox.removeClass('in-progress overlayCopy hide');
            // CLOSE OVERLAY
            $('.close-overlay-box').on('click keydown', function (e) {
                if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.which === 13))) {
                    if (isOverlayWebviewMode()) {
                        sendCloseWebviewEventToDevice('CANCELLATION');
                    } else {
                        if (typeof cartWithoutTimeslot != 'undefined' && cartWithoutTimeslot) {
                            gaPushOnOverlayClick('I haven\'t made my choice yet');
                            submitCartCreation();
                            if (typeof TINK.getCookie('hide_product_overlay_add_click') != 'undefined') {
                                restCountAddToCart = false;
                                currentNbAddToCart = 1;
                            }
                        } else {
                            removeOverlayServiceBox();
                            gaPushOnOverlayClick('I haven\'t made my choice yet');
                        }

                        if ($('#cartGeniusModal').length) {
                            $('.modal__close.focusable').trigger('click');
                        }
                    }
                }
            });

            formatServicePostalCode.formatInput($overlayInputField, OVERLAY);

        }

        bindButtons();
        bindOverlaySelectService($cloneOverlayServiceBox);
        manageOverlayOuterClick();

        if (!fromSearch) {
            gaPushOnOverlayView();
        }

        TINK.updateStatusNotification(window['overlayOpenMessage']);
        TINK.trapFocus($cloneOverlayServiceBox, removeOverlayServiceBox);
    };

    function attemptToCreateCartWithoutDisplayingOverlay($targetTileTrigger, errorBox) {
        productToAddToCart = $targetTileTrigger;
        errorBoxForAddToCart = errorBox;

        let $productContainer = $targetTileTrigger.closest('.item-addToCart');
        TINK.inProgress($productContainer);

        // Attempt to create cart without displaying the overlay
        $.ajax({
            url: overlayCartCreationUrl,
            type: 'GET',
            contentType: 'application/json',
            cache: false,
            success: function (data, code, jqXHR) {
                cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
                ServiceTimeslot.updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                }

                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                // execute addToCart after overlay is closed
                window['storeId'] = false;

                // update cartWithoutTimeslot variable in JS when page will not be reloaded
                ServiceTimeslot.updateCartWithoutTimeslot(true);

                // to force reload after add to cart
                window['forceReloadAfterNextAddToCart'] = true;

                onCloseOverlayAfterServiceSelection();
            },
            error: function () {
                findServiceByPostalCode(undefined, $targetTileTrigger, errorBox, false); // If error, fallback to overlay
            }, complete: function () {
                TINK.stopProgress($productContainer);
            }
        });
    }

    function findServiceByPostalCode(postalCode, targetTileTrigger, errorBox, fromSubmit) {
        if (typeof postalCode == 'undefined') {
            postalCode = '';
        }

        let url = displayOverlayProductUrl + '?postalCode=' + postalCode + '&fromSubmit=' + fromSubmit;
        productToAddToCart = targetTileTrigger;
        errorBoxForAddToCart = errorBox;

        let $productContainer = targetTileTrigger.closest('.item-addToCart');
        TINK.inProgress($productContainer);

        $.ajax({
            url: url,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            cache: false,
            success: function (data) {
                replaceContentOverlay(data, targetTileTrigger, fromSubmit);
            },
            error: function (jqXHR) {
                if (jqXHR.status === 500) {
                    openOverlayServiceBox(targetTileTrigger);
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
                displayErrorOverlay(overlayGenericErrorMsg);
            },
            complete: function () {
                TINK.stopProgress($productContainer);
            }
        });
    }

    function loadDeliverySecondScreen($postalCode) {
        $.ajax({
            url: overlayDeliveryChoiceUrl+'?postalCode='+$postalCode,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            cache: true,
            success: function (data, jqXHR) {
                $('.overlayMain:not(.overlayCopy)').html(data);
                $(".delivery-second-container .confirm-delivery").prop('disabled', true);
                //en desktop on affiche un titre plus court si petite tuile pour la deuxieme etape de livraison
                if (Revealizr.isDesktopSize && $('.overlayMain:not(.overlayCopy)').parent().innerHeight() < 400) {
                    $('.short-title').css('display', 'block');
                    $('.long-title').css('display', 'none');
                }
                $('.overlayMain:not(.overlayCopy)').removeClass('in-progress hide');
                TINK.trapFocus($('.overlayServiceBox.overlay-service-box.overlayMain:not(.overlayCopy)'), removeOverlayServiceBox);
            },
            error: function (jqXHR) {
                if (jqXHR.status === 500) {
                    let $overlayMain = $('.overlayMain:not(.overlayCopy)');
                    $overlayMain.find('.box__select-service').addClass('hide');
                    $overlayMain.find('.service-box_postal-actions .confirm').addClass('hide');
                    $overlayMain.find('.overlay-generic-error').removeClass('hide');
                    $overlayMain.removeClass('in-progress hide');
                    $('#servicePostalCodeBox').focus();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
            }
        });
    }

    let cartAssignationInProgress = false;

    function createCartAndHandleAssignation(serviceTypeChosen, storeId, deliveryPostalCode, servicePointId, slotId, partnerCode, assignTimeslot, slotFrom, slotTo, slotDeliveryPartner, slotStoreId) {
        if (cartAssignationInProgress) {
            return;
        }
        cartAssignationInProgress = true;

        let formStateId = $('.overlayServiceBox').data('form-state-id');
        let recaptchaResponse = overlayCaptcha.getResponse();

        let $body = $('body');
        TINK.inProgress($body);
        $.ajax({
            url: overlayAssignationUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify({
                'serviceType': serviceTypeChosen,
                'storeId': storeId,
                'deliveryPostalCode': deliveryPostalCode,
                'servicePointId': servicePointId,
                'partnerCode': partnerCode,
                'g-recaptcha-response': recaptchaResponse,
                'formStateId': formStateId,
                'assignTimeslot': assignTimeslot,
                'slot': slotId,
                'slotStoreId': slotStoreId,
                'slotDeliveryPartner': slotDeliveryPartner,
                'slotFrom': slotFrom,
                'slotTo': slotTo
            }),
            cache: false,
            success: function (data, code, jqXHR) {
                cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
                ServiceTimeslot.updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                    window['forceReloadAfterNextAddToCart'] = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                    window['forceReloadAfterNextAddToCart'] = true;
                }

                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                // execute addToCart after overlay is closed
                if (slotId != null) {
                    window['storeId'] = false;
                }

                // update cartWithoutTimeslot variable in JS when page will not be reloaded
                if (assignTimeslot && slotId != null) {
                    ServiceTimeslot.updateCartWithoutTimeslot(false);
                } else {
                    ServiceTimeslot.updateCartWithoutTimeslot(true);
                }

                onCloseOverlayAfterServiceSelection();

                if (isInWebview()) {
                    sendWebviewReloadCartToDevice();
                }

                removeOverlayServiceBox();
            },
            error: function (jqXHR) {
                if (jqXHR.status === 400) {
                    if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                        cartStoreHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                        cartTypeHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('recaptchaFailed') === 'true') {
                        displayErrorOverlay(overlayRecaptchaErrorMsg);
                        overlayCaptcha.resetCaptcha();
                        return false;
                    }

                    cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
                    ServiceTimeslot.updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                    overlayCaptcha.resetCaptcha();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
                displayErrorOverlay(overlayGenericErrorMsg);
            },
            complete: function () {
                TINK.stopProgress($body);
                cartAssignationInProgress = false;
            }
        });
    }

    function displayErrorOverlay(errorMsg) {
        let $overlayServiceBox = $('.overlayServiceBox:not(.overlayCopy)');
        if (errorMsg) {
            $overlayServiceBox.find('.overlayErrorMsg').text(errorMsg);
        }
        $overlayServiceBox.addClass('error-msg');
    }

    function onCloseOverlayAfterServiceSelection() {
        if (!cartHasStore) {
            window['cartItem'] = null;
        }

        let reloadPageAuthorized = true;
        if (window['cartItem'] && !window['storeId']) {
            window['executeAddProductToCart'](productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, true, false);
        }

        if (window['isCartGeniusOpened'] && !window['storeId']) {
            if (isReloadPageAuthorizedForProductOverlay(reloadPageAuthorized)) {
                // After reload, we automatically open Cart Genius
                sessionStorage.setItem('triggerOpeningCartGeniusAfterReload', true);
                sessionStorage.setItem('forceCartGeniusCacheInvalidation', true);
                reloadPage();
            } else {
                CartGeniusBanner.openCartGeniusDetails();
            }
        }
    }

    function isReloadPageAuthorizedForProductOverlay(reloadPageAuthorized) {
        return (reloadPageAuthorized && cartStoreHasChanged) || (window.location.pathname === shoppingCartUrl);
    }

    function handleCartCreation(assignTimeslot) {

        let $optionChecked = $('.delivery-second-container input[name="storeSelection"]:checked');
        //appel apartir du link ('je n"ai pas encore fait mon choix ')
        if ($optionChecked.length == 0) {
            //Prendre les infos du service en cours
            let $serviceSelected = $('.overlayServiceBox:not(.overlayCopy)').find('.store-to-assign.current-store input');
            let $serviceType = $serviceSelected.attr('data-hybris-service-type');
            let $storeId = $serviceSelected.attr('data-store-id');
            let $postalCode = $serviceSelected.attr('data-postal-code');
            let $servicePointId = $serviceSelected.attr('data-service-point-id');
            let $slotId = $serviceSelected.attr('data-slot-id');
            let $slotStoreId = $serviceSelected.attr('data-slot-store-id');
            let $slotFrom = $serviceSelected.attr('data-slot-from');
            let $slotTo = $serviceSelected.attr('data-slot-to');
            let $slotDeliveryPartner = $serviceSelected.attr('data-slot-deliveryPartner');
            createCartAndHandleAssignation($serviceType, $storeId, $postalCode, $servicePointId, $slotId, null, assignTimeslot, $slotFrom, $slotTo, $slotDeliveryPartner, $slotStoreId);
        } else {
            //a partir de la liste qui affiche le type de services livraisons
            //2 cas traités: la selection de l'option eclair 2h ou moins / ou l'option choisir plus tard
            let $serviceType = $optionChecked.data('service-type-selected');
            let $storeId = $optionChecked.data('store-id');
            let $servicePointId = $optionChecked.data('service-point-id');
            let $deliveryPostalCode = $optionChecked.data('delivery-postal-code');
            //2h et moins cré un panier, pas d'ouverture du panneau de droite
            if ($serviceType === SERVICE_TYPE_CORNER_SHOP_DELIVERY) {
                createCartAndHandleAssignation($serviceType, $storeId, $deliveryPostalCode, $servicePointId, null, null, null, null, null, null, null);
                gaPushOnOverlayClick('confirm', 'delivery', 'eclair');
            } else if ($serviceType === CHOOSE_LATER) {
                createCartAndHandleAssignation('HOME_DELIVERY', $storeId, $deliveryPostalCode, $servicePointId, null, null, null, null, null, null, null);
                gaPushOnOverlayClick('choose later');
            }
        }
    }

    function bindButtons() {
        let $postalCodeSubmit = $('.overlayServiceBox').find('.postalCode_submit');
        let $confirmDelivery = $('.overlayServiceBox').find('.confirm');
        if ($postalCodeSubmit.length) {
            $postalCodeSubmit.prop('disabled', false);
        }
        $postalCodeSubmit.click(function (e) {
            e.preventDefault();
            $(this).prop('disabled', true);

            let $productTileContent;

            if ($('#frequently-bought-together').length && $(this).closest('.item-addToCart').hasClass('productPDP') ) {
                $productTileContent = $(this).closest('.pdpDetailsContainer');
            } else if ($('#cartGeniusContent').length && $(this).closest('.cartGeniusContainer').length > 0) {
                $productTileContent = $(this).closest('.cartGeniusContainer');
            } else if ($('#cartGeniusModal').length && $(this).closest('#cartGeniusModal').length > 0) {
                $productTileContent = $(this).closest('#cartGeniusModal');
            } else {
                $productTileContent = $(this).closest('.item-addToCart').find('.pt__content');
            }

            if (!$productTileContent.length) {
                $productTileContent = $(this).closest('.pdpDetailsContainer');
                if (!$productTileContent.length) {
                    $productTileContent = $(this).closest('.overlayServiceBox').parent().find('.item-addToCart .pt__content');
                }
            }

            if (isOverlayWebviewMode()) {
                $productTileContent = $('#overlay-webview');
            }
            let $postalCode = $('#servicePostalCodeBox').val();
            findServiceByPostalCode($postalCode, $productTileContent, errorBoxForAddToCart, true);
        });

        $confirmDelivery.click(function () {
            let $postalCode = $(this).attr('postal-code');
            if (typeof $postalCode !== 'undefined') {
                loadDeliverySecondScreen($postalCode);
                sessionStorage.setItem('enteredPostalCode', $postalCode);
            }
        });

        $('.overlayServiceBox').find('.openTimeSlotPanel:not(.pickup)').click(function () {
            pushDataLayerPanelView(this);
            ServiceTimeslot.openServiceAndTimeslot.bind(this)(undefined, productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, undefined);
        });

        let $pickupLabel = $('.overlayServiceBox:not(.overlayCopy)').find('.st__serviceType label[for="overlayServicePickup"]');

        $pickupLabel.on('click keydown', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.which === 13))) {
                let $pickupInput = $('.overlayServiceBox:not(.overlayCopy)').find('.st__serviceType #overlayServicePickup');
                if (!$pickupInput.prop('disabled')) {
                    if (e.key === 'Enter' || e.which === 13){
                        $('#overlayServicePickup').trigger("click");
                    }
                    loadPickupSecondScreen();
                }
            }
        });

        $(document).on('change', 'input[type=radio][name=storeSelection]', function () {
            $(".delivery-second-container .confirm-delivery").prop('disabled', false);

            const $modal = $('.overlayServiceBox.overlay-service-box.overlayMain:not(.overlayCopy)');

            // Only call trapFocus if it hasn't been called yet for this modal
            if (!$modal.data('trapFocusBound')) {
                TINK.trapFocus($modal, removeOverlayServiceBox);
                $modal.data('trapFocusBound', true); // mark as bound
            }
        });

        $('.overlayServiceBox').find('.chooseLater').click(function () {
            if (!isOverlayWebviewMode()) {
                gaPushOnOverlayClick('choose later');
                $(this).prop('disabled', true);
                submitCartCreation();
            }
        });

        $('.overlayServiceBox').find('.reserve-timeslot').click(function () {
            if (!isOverlayWebviewMode()) {
                gaPushOnOverlayClick('reserve timeslot');
                $(this).prop('disabled', true);
                handleCartCreation(true);
            }
        });
    }

    //Le lien de Modification d'un code postal lors d'un panier ou non sans Ts avec le service livraison.
    $(document).on('click', '.service-box_postal-code .modify-address', function () {
        gaPushOnOverlayClick('modify');
        $('.service-box_wrapper.delivery-section').removeClass('hide')
        $('.service-box_postal-code.service--overview').hide();
        $('.service-box_wrapper.delivery-section').css('display', 'flex');
        $(this).closest($('.service-box_postal-code.service--overview')).hide();
        $('.service-box_postal-actions .delivery-button').hide();
        $('.service-box_wrapper.pickup-section').hide();
    });

    //Le click sur afficher les autres magasins
    $(document).on('click', '.show-more-store', function () {
        gaPushOnOverlayClick('other shops');
        let $selectedOption = $('#preSelectedPickupStores :selected');
        $(".countryField option[value='Canada']").attr("selected", "selected");
        let $deliveryPostalCode = $selectedOption.data('delivery-postal-code');
        let $choiceTypeService = 'PICK_UP_IN_STORE';
        loadModifyPanel($choiceTypeService, $deliveryPostalCode);
        $('.st_panel.rightPanel').remodal().open();
    });

    $(document).on('click keydown', '.overlayServiceBox .st__serviceType label[for="overlayServiceDelivery"]', function (e) {
        if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.which === 13))) {
            //close dropdown if open
            let $variantSelector = $('.action__select-variant.active');
            if ($variantSelector.length) {
                $('.overlayServiceBox.overlay-service-box.overlayMain').trigger('click');
            }

            if (e.key === 'Enter' || e.which === 13){
                $('#overlayServiceDelivery').trigger("click");
            }

            $('#deliveryRadio').trigger("click");
            //afficher le bloc(livraison au...) pour une livraison avec cart ou livraison sans cart
            //lorsque le rappel pour choisir une ts est affiché sur la tuile
            if ($('.deliveryWithCart').length || $('.deliveryWithoutCart').length) {
                //cacher la liste des pickup
                $('.overlayMain:not(.overlayCopy) .pickup-second-container').hide();
                $('.overlayMain:not(.overlayCopy) .service-box_wrapper:hidden').show();
                //Afficher le btn de livraison qui redirige vers le paneau de droite
                $('.overlayServiceBox .openTimeSlotPanel').removeClass('hide');

                //La partie qui affiche le le bloc de livraison
                $('.service-box_postal-code.service--overview').show();
                $('.service-box_wrapper.delivery-section').addClass('hide');
            } else {
                //afficher le bloc de la saisie de code postal
                //cacher la liste des pickup
                $('.overlayMain:not(.overlayCopy) .pickup-second-container').addClass('hide');
                $('.service-box_wrapper.delivery-section').removeClass('hide');
                $('.service-box_wrapper.delivery-section').show();
                $('.service-box_wrapper.delivery-section').css('display', 'flex');
                $('.service-box_wrapper.pickup-section').css('display', 'none');
            }
        }
    });

    //dans le overlay, pour un ramassage, une fois qu'un magasin est choisie dans la liste, le panneau de droite des TS sera ouvert
    $(document).on('click', '.pickup-second-container .pickup.openTimeSlotPanel', function () {
        let $selectedOption = $('#preSelectedPickupStores :selected');
        if (!isOverlayWebviewMode()) {
            if ($selectedOption !== undefined && $selectedOption.length >= 1) {
                //le pickup selectioné dans la liste
                let storeId = $selectedOption.attr('data-store-id');
                let postalCode = $selectedOption.attr('data-delivery-postal-code');
                pushDataLayerPanelView(this);
                gaPushOnOverlayClick('confirm', 'pickup', 'regular');
                ServiceTimeslot.openServiceAndTimeslot.bind(this)(postalCode, productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, undefined, storeId);
            }
        }
    });

    //Pour une livraison, il y a un écran qui va s'afficher les types de livraisons dispo (2h, express, écono..)
    $(document).on('click', '.delivery-second-container .availableService.confirm-delivery', function (e) {
        let $optionChecked = $('.delivery-second-container input[name="storeSelection"]:checked');
        let $serviceType = $optionChecked.data('service-type-selected');
        //2h et moins crée un panier, pas d'ouverture du panneau de droite ou la selection de choisir plus tard
        if ($serviceType === SERVICE_TYPE_CORNER_SHOP_DELIVERY || $serviceType === CHOOSE_LATER ) {
            //execute addToCart
            window['storeId'] = false;
            submitCartCreation();
            //Les autres types de livraison : pas de panier créé, ouvrir le panneau de droite
        } else if ($serviceType === SERVICE_TYPE_EXPRESS_DELIVERY) {
            let $deliveryPostalCode = $optionChecked.data('delivery-postal-code');
            //le type de livraison choisie pour se positionner à la bonne TS à l'ouverture du panneau de droite
            let $deliveryFavoriteTs = $optionChecked.data('delivery-favorite-ts-id');
            pushDataLayerPanelView(this);
            ServiceTimeslot.openServiceAndTimeslot.bind(this)($deliveryPostalCode, productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, undefined, undefined, $deliveryFavoriteTs);
            gaPushOnOverlayClick('confirm', 'delivery', 'express');
        } else if ($serviceType === SERVICE_TYPE_ECONO_DELIVERY) {
            let $deliveryPostalCode = $optionChecked.data('delivery-postal-code');
            //le type de livraison choisie pour se positionner à la bonne TS à l'ouverture du panneau de droite
            let $deliveryFavoriteTs = $optionChecked.data('delivery-favorite-ts-id');
            pushDataLayerPanelView(this);
            ServiceTimeslot.openServiceAndTimeslot.bind(this)($deliveryPostalCode, productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, undefined, undefined, $deliveryFavoriteTs);
            gaPushOnOverlayClick('confirm', 'delivery', 'econo');
            // l'option plus tard : crée le panier, pas d'ouverture du panneau de droite
        }
    });

    function bindOverlaySelectService(overlayServiceBox) {
        overlayServiceBox.find('[name="overlay-select-timeslot"]').change(function () {
            //note current-store , actuellement dans le overlay que ca soit pick ou delivery ( option jai pas encore choisi ne change pas le service en cours)
            let $storeToAssign = $('.overlayServiceBox:not(.overlayCopy)').find('.store-to-assign:not(.current-store) input');
            $storeToAssign.data('hybris-service-type', $(this).data('hybris-service-type'));
            $storeToAssign.data('store-id', $(this).data('store-id'));
            $storeToAssign.data('postal-code', $(this).data('postal-code'));
            if ($(this).data('service-point-id')) {
                $storeToAssign.data('service-point-id', $(this).data('service-point-id'));
            } else {
                $storeToAssign.removeAttr('data-service-point-id');
            }
        });
    }

    function bindCaptcha() {
        overlayCaptcha.removeCaptcha();
        overlayCaptcha.renderCaptcha();
    }

    function submitCartCreation() {
        if (overlayCaptcha.isEnabledAndInvisible()) {
            overlayCaptcha.executeCaptcha();
        } else {
            handleCartCreation(false);
        }
    }

    window['executeOverlayCartCreation'] = function () {
        handleCartCreation(false);
    }

    function replaceContentOverlay(data, targetTileTrigger, fromSearch) {
        data = data.trim();
        let $overlay = $('.overlayServiceBox.overlayCopy.hide');
        $overlay.replaceWith(data);
        openOverlayServiceBox(targetTileTrigger, fromSearch);

        let $activeOverlay = $('.overlayServiceBox:not(.overlayCopy)');

        let $overlayRecaptcha = $('.product-overlay-captcha');
        let $overlayRecaptchaWrapper = $('.product-overlay-captcha-wrapper');
        if ($overlayRecaptcha.length && $overlayRecaptchaWrapper.length) {
            $overlayRecaptchaWrapper.append($overlayRecaptcha).ready(bindCaptcha);
        }

        if (data !== '') {
            let postalCodeValue = $('#servicePostalCodeBox').val();

            $('#servicePostalCodeBox').focus();
            //Activer par defaut le btn livraison dans le overlay lors de la recherche avec le code postal
            if (typeof activeDeliverySwitchAsDefault != 'undefined' && activeDeliverySwitchAsDefault) {
                $('#overlayServiceDelivery').trigger("click");
            }
            // pour le overlay, Si y a pas de livraison dispo avec le cp rempli, afficher le message d'erreur
            if (typeof postalCodeValue != 'undefined' && postalCodeValue.length === 7 && typeof serviceDeliveryUnavailable != 'undefined' && serviceDeliveryUnavailable) {
                $activeOverlay.find('.box__select-service').addClass('hide');
                $activeOverlay.find('.service-box_postal-actions .confirm').addClass('hide');
                $activeOverlay.find('.alert-no-delivery-service').removeClass('hide');
                $activeOverlay.find('.alert-no-delivery-service').addClass('large');
                $('#servicePostalCodeBox').focus();
            }
            //defaultFSAPostalCode : si cest fsa(3 digits) n'affiche pas le message d'erreur
            //Si aucun service livraison et pick de dispo on affiche aussi un message d'erreur
            if (typeof postalCodeValue != 'undefined' && postalCodeValue.length != 0 && typeof serviceDeliveryAndPickupUnavailable != 'undefined' && serviceDeliveryAndPickupUnavailable && !defaultFSAPostalCode) {
                $activeOverlay.find('.box__select-service').addClass('hide');
                $activeOverlay.find('.service-box_postal-actions').addClass('hide');
                $activeOverlay.find('.alert-no-service').removeClass('hide');
                $('#servicePostalCodeBox').focus();
            }
        }
    }

    function isOverlayWebviewMode() {
        return isInWebview() && typeof overlayWebviewMode !== 'undefined' && overlayWebviewMode;
    }

    function bindWebviewEvents() {
        if (isAuthenticated) {
            let $targetTile = $('#overlay-webview');
            let $postalCode = $targetTile.attr('service-timeslot-postalcode');
            showOverlayServiceBox.findServiceByPostalCode($postalCode, $targetTile, null, false);
        } else {
            // send event to redirect to connection page in the App
            sendUserNotAuthenticatedEventToDevice();
            return;
        }
    }

    function loadPickupSecondScreen() {
        if ($('.overlayMain:not(.overlayCopy) .pickup-second-container').length) {
            $('#pickUpRadio').trigger("click");
            $('.overlayMain.overlayCopy .pickup-second-container').remove();
            $('.overlayMain.overlayCopy .st__serviceType').remove();
            $('.overlayMain:not(.overlayCopy) .pickup-second-container').removeClass('hide');
            $('.overlayMain:not(.overlayCopy) .pickup-second-container').show();
            $('.overlayMain:not(.overlayCopy) .service-box_wrapper:last').hide();
        }
    }

    function pushDataLayerPanelView(element) {
        const isInside = $(element).closest('.cartGeniusContainer, .cartGenius--banner').length > 0;
        if (isInside) {
            onPanelView('cart genius', false);
        } else {
            onPanelView('product tile overlay', false);
        }
    }

    return {
        initWebviewOverlay: initWebviewOverlay,
        removeOverlayServiceBox: removeOverlayServiceBox,
        findServiceByPostalCode: findServiceByPostalCode,
        createCart: attemptToCreateCartWithoutDisplayingOverlay,
        isOverlayWebviewMode: isOverlayWebviewMode,
        handleOuterClick: handleOuterClick
    }
}();

$(document).ready(function () {
    if (showOverlayServiceBox.isOverlayWebviewMode()) {
        showOverlayServiceBox.initWebviewOverlay();
    }
});